import { createEnum } from "@redotech/zod/zod-enum";

export const workflowTypes = [
  "returnCreationSideEffects",
  "returnProcessSideEffects",
  "postReturnProcessSideEffects",
  "returnReadySideEffects",
  "postReturnReadySideEffects",
  "exchangeConversionWorkflow",
] as const;

export type WorkflowType = (typeof workflowTypes)[number];

export const WorkflowTypeSchema = createEnum(workflowTypes);
